<ksg-app-layout
  [sections]="sections()"
  [activeUrl]="activeUrl()"
  storageKey="kadry-sidebar-collapsed"
  [sidebarAriaLabel]="'topbar.mainNav' | transloco"
  [sidebarCollapseLabel]="'topbar.collapseMenu' | transloco"
  [sidebarExpandLabel]="'topbar.expandMenu' | transloco"
>
  <ksg-topbar
    appTopbar
    showMenuButton
    [menuButtonLabel]="'topbar.toggleMenu' | transloco"
  >
    <a
      topbarStart
      class="app-brand-link"
      routerLink="/"
      [attr.aria-label]="'topbar.home' | transloco"
    >
      <app-brand-logo />
    </a>

    <ng-container topbarEnd>
      <ksg-session-timer
        [active]="auth.isAuthenticated()"
        [remainingSeconds]="session.remainingSeconds()"
        [isWarning]="session.isWarning()"
        [displayTime]="session.displayTime()"
        (extend)="session.extend()"
        (logout)="auth.logout()"
      />
      <ksg-theme-toggle
        showContrast
        [toLightLabel]="'topbar.themeLight' | transloco"
        [toDarkLabel]="'topbar.themeDark' | transloco"
        [contrastLabel]="'topbar.contrast' | transloco"
      />
      <ksg-button
        variant="text"
        iconOnly
        rounded
        icon="pi-flag"
        routerLink="/zgloszenia"
        [queryParams]="{ new: 1 }"
        [ariaLabel]="'topbar.reportProblem' | transloco"
      />
      <app-tour-button />
      <ksg-language-selector />
    </ng-container>
  </ksg-topbar>

  <ng-template appSidebarFooter let-collapsed>
    <app-company-switcher [collapsed]="collapsed" />
    <ksg-user-panel
      [name]="'topbar.admin' | transloco"
      [role]="'topbar.adminRole' | transloco"
      [collapsed]="collapsed"
      [menuLabel]="'topbar.userMenu' | transloco"
      [logoutLabel]="'auth.logout' | transloco"
      (logout)="auth.logout()"
    />
  </ng-template>

  <app-demo-notice variant="bar" />
  <router-outlet />
</ksg-app-layout>

<ksg-toast position="top-right" />
<app-tour-overlay />
